import 'twin.macro';
import Image from '@leuven2030/framework/Image/Image';
import PrismicText from '@leuven2030/framework/Prismic/PrismicText';

export const ContentQuoteQuery = ({ typeName }) => `
        ... on ${typeName}BodyQuote {
          type
          primary {
            text
            image {
              ... on _ImageLink {
                url
              }
            }
            name
            function
          }
        }
`;

const ContentQuote = ({
  data: { image, text, name, function: personFunction }
}) => {
  function getImageNode() {
    if (!image) {
      return <></>;
    }
    const imageProps = {
      src: image.url,
      imgixParams: { fit: 'facearea', facepad: 2 },
      width: 256,
      height: 256
    };

    return (
      <div tw="flex-shrink-0">
        <Image tw="h-12 w-12 md:(h-20 w-20) rounded-full" {...imageProps} />
      </div>
    );
  }

  return (
    <div tw="max-w-lg bg-gray-100 p-6 my-12 overflow-hidden rounded">
      <div tw="relative flex-1 ">
        <blockquote tw="relative ">
          <PrismicText tw="prose-sm max-w-full!" text={text} />
          <footer tw="mt-4">
            <div tw="flex space-x-3 items-center">
              {getImageNode()}
              <div tw="ml-4 lg:ml-0">
                <div
                  tw="text-base font-medium text-gray-900"
                  className="font-sohne"
                >
                  {name}
                </div>
                <div tw="text-sm font-medium text-gray-600">
                  {personFunction}
                </div>
              </div>
            </div>
          </footer>
        </blockquote>
      </div>
    </div>
  );
};

ContentQuote.type = 'quote';

export default ContentQuote;
